import React, { createContext, useContext, useState, useEffect } from 'react';

const ApiKeyContext = createContext();

export function useApiKey() {
  return useContext(ApiKeyContext);
}

export function ApiKeyProvider({ children }) {
  const [apiKey, setApiKey] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Carregar a API Key do localStorage quando o componente for montado
    const storedApiKey = localStorage.getItem('ikaro_api_key');
    if (storedApiKey) {
      setApiKey(storedApiKey);
    }
    setLoading(false);
  }, []);

  const saveApiKey = (key) => {
    localStorage.setItem('ikaro_api_key', key);
    setApiKey(key);
  };

  const clearApiKey = () => {
    localStorage.removeItem('ikaro_api_key');
    setApiKey('');
  };

  const value = {
    apiKey,
    saveApiKey,
    clearApiKey,
    loading
  };

  return (
    <ApiKeyContext.Provider value={value}>
      {children}
    </ApiKeyContext.Provider>
  );
} 